// extracted by mini-css-extract-plugin
module.exports = {"root":"Fact_root__BSeq3","imageWrapper":"Fact_imageWrapper__Mvy9U","content":"Fact_content__Y2Hi6","title":"Fact_title__UI59T","text":"Fact_text__i6jn3"};